/**
 * Builds a Mongo query-builder filter for searching people by name or email.
 * Tokenizes multi-word input so "John Smith" matches firstName/lastName separately
 * rather than requiring the full string to match a single field.
 */
export function buildNameEmailSearchQuery(
  search: string,
): Record<string, unknown> | null {
  const words = search.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return null;

  const wordConditions = words.map(word => ({
    $or: [
      { firstName: { $regex: word } },
      { lastName: { $regex: word } },
      { email: { $regex: word } },
    ],
  }));

  if (wordConditions.length === 1) {
    return wordConditions[0];
  }

  return { $and: wordConditions };
}
